<div class="container m-b-5">
  <div class="row animate fadeIn">
    <div class="col-12">
      <button (click)="regresarPagina()" style="width: 100px; height: 40px; padding: 0px; border: 0px;" class="btn btn-outline-info"><i class="fa fa-hand-o-left" style="margin-right: 8px;"></i>Regresar</button>

      <div class="card">
        <div class="card-body">
          <input #input (keyup)="buscarContratos(input.value)" type="text" class="form-control"
            placeholder="Buscar contratos...">
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <h3 class="card-title">Contratos registrados (<small>{{_contratoService.totalContratos}}</small>)</h3>
          <table class="table table-hover table-responsive-xl" style="width:100%; overflow-x: auto;">
            <thead>
              <tr>
                <th style="text-align: center;"><b>Nombre del contrato</b></th>
                <th style="text-align: center;"><b>Inicio del contrato</b></th>
                <th style="text-align: center;"><b>Fin del contrato</b></th>
                <th style="text-align: center;"><b>Meses de alquiler</b></th>
                <th style="text-align: center;"><b>Acciones</b></th>
              </tr>
            </thead>

            <div class="alert alert-info" *ngIf="contratos.length === 0" >
              No hay resultados de la búsqueda
          </div>


            <tbody>
              <tr *ngFor="let contrato of contratos">
                <td>{{contrato.nombrecontrato}}</td>
                <td style="text-align: center;">{{contrato.fechainicio|date:'dd-MM-yyyy'}}</td>
                <td style="text-align: center;">{{contrato.fechafin|date:'dd-MM-yyyy'}}</td>
                <td style="text-align: center;">{{contrato.tiempocontrato}}</td>
                <td style="text-align: center;">
                  <button [routerLink]="['/plantillacontrato', contrato._id]" class="btn btn-primary"><i
                    class="fa fa-eye"></i></button>
                </td>
              </tr>
            </tbody>
          </table>

          <button (click)="cambiarPaginacion(-5)" class="btn btn-circle btn-lg btn-success mr-2"><</button>
          <button (click)="cambiarPaginacion(5)" class="btn btn-circle btn-lg btn-success">></button>

</div>

